import utils from './utils';

window.onGoogleMapsReady = utils.synchronizer();
